import React from 'react';

export const FeesTabSkeleton: React.FC = () => {
  return (
    <div className="w-full h-[calc(100vh-200px)] overflow-hidden flex flex-col">
      {/* Tab Navigation Skeleton */}
      <div className="border-b border-[#E4E8EA] mb-4 flex-shrink-0">
        <div className="flex gap-6 pb-4">
          <div className="h-6 w-24 bg-gray-300 rounded animate-pulse"></div>
          <div className="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>

      {/* Fee Cards Panel Skeleton */}
      <div className="flex-1 overflow-auto">
        <div className="space-y-4 p-4">
          {[...Array(2)].map((_, sessionIndex) => (
            <div
              key={sessionIndex}
              className="bg-white rounded-lg border border-[#E4E8EA] overflow-hidden"
              style={{ animationDelay: `${sessionIndex * 0.1}s` }}
            >
              {/* Session Header Skeleton */}
              <div className="p-3 flex items-center justify-between animate-pulse">
                <div className="space-y-2">
                  <div className="h-5 w-48 bg-gray-200 rounded"></div>
                  <div className="flex items-center gap-4">
                    <div className="h-4 w-24 bg-gray-100 rounded"></div>
                    <div className="h-4 w-24 bg-gray-100 rounded"></div>
                    <div className="h-4 w-24 bg-gray-100 rounded"></div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="h-8 w-28 bg-gray-200 rounded"></div>
                  <div className="h-5 w-5 bg-gray-200 rounded-full"></div>
                </div>
              </div>

              {/* Fee Types Table Skeleton */}
              <div className="border-t border-[#E4E8EA] overflow-x-auto">
                <table className="w-full min-w-[800px]">
                  <thead className="bg-[#F5F8F9]">
                    <tr>
                      <th className="w-8 p-4">
                        <div className="h-5 w-5 bg-gray-200 rounded"></div>
                      </th>
                      {[...Array(7)].map((_, i) => (
                        <th key={i} className="p-4 text-left">
                          <div className="h-5 w-24 bg-gray-200 rounded"></div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(3)].map((_, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className="border-t border-[#E4E8EA]"
                        style={{ animationDelay: `${rowIndex * 0.05}s` }}
                      >
                        <td className="p-4">
                          <div className="h-5 w-5 bg-gray-200 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-24 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-32 bg-gray-200 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-24 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-32 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-16 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-16 bg-gray-100 rounded"></div>
                        </td>
                        <td className="p-4">
                          <div className="h-5 w-24 bg-gray-200 rounded"></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Session Footer Skeleton */}
                <div className="border-t border-[#E4E8EA] p-3 bg-white">
                  <div className="flex items-center gap-2">
                    <div className="px-4 py-2 flex items-center gap-2 animate-pulse">
                      <div className="h-4 w-4 bg-gray-200 rounded-full"></div>
                      <div className="h-5 w-48 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
